import React, { useState, useEffect } from "react";

const Slider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentIndex === images.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex, images]);

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <img src={images[currentIndex]} alt="slider" />
    </div>
  );
};

export default Slider;
